export default function extractModuleNames(modules) {
    return modules.map((m) => m.config.name);
}
